import { isAllPurposesAccepted } from '@ecg-marktplaats/gdpr-consent-string';
import LOG_EVENT_STATE from '../constants/LOG_EVENT_STATE';
import queueCallback from './queueCallback';
import logException from './logException';

/**
 * Keeps track of whether an event has been fired or not
 * So we only fire events once
 */
export const hasEventBeenFired = new Set();

const logGAEvent = (eventAction) => {
  // @ts-ignore
  if (!window.ecGa) {
    queueCallback(logGAEvent, eventAction);

    logException(`${LOG_EVENT_STATE.QUEUED}: ${eventAction}`, {
      level: 'info',
    });

    return LOG_EVENT_STATE.QUEUED;
  }

  if (hasEventBeenFired.has(eventAction)) {
    logException(`${LOG_EVENT_STATE.ALREADY_FIRED}: ${eventAction}`, {
      level: 'info',
    });

    /**
     * Only fire events once
     */
    return LOG_EVENT_STATE.ALREADY_FIRED;
  }

  try {
    hasEventBeenFired.add(eventAction);
    // @ts-ignore
    window.ecGa('trackEvent', {
      eventLabel: 'gdpr-bottom-banner',
      eventAction: `${eventAction}`,
      dimension188: `TCF 2: ${isAllPurposesAccepted() ? 'Consent Given' : 'No Consent Given'}`,
    });

    return LOG_EVENT_STATE.FIRED;
  } catch (error) {
    logException(error, {
      level: 'warning',
    });
    return LOG_EVENT_STATE.FAILED;
  }
};

export default logGAEvent;
